export const CustomTooltip = ({ active, payload, label }) => {
  if (!active || !payload || payload.length === 0) return null;

  return (
    <div className="bg-white/10 backdrop-blur border border-gray-200 rounded-xl shadow-[0_8px_24px_rgba(16,24,40,0.12)] p-4 max-w-[320px]">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="font-semibold text-gray-900 text-sm truncate">{label}</p>
      </div>

      <div className="flex items-center w-fit gap-2 rounded-3 border border-gray-300 p-2">
        <span className="text-xs font-medium">
          {payload[0].payload.performanceLabel ?? "نا مشخص"}
        </span>
      </div>
    </div>
  );
};
